import { useQuery } from "@tanstack/react-query"
import { conversationOpportunitiesQuery } from "../lib/conversationOpportunitiesQuery"

export function useConversationOpportunitiesQuery(
  ...args: Parameters<typeof conversationOpportunitiesQuery>
) {
  return useQuery(conversationOpportunitiesQuery(...args))
}
